import { render, staticRenderFns } from "./LayoutHomePage.vue?vue&type=template&id=c5184692&"
import script from "./LayoutHomePage.vue?vue&type=script&lang=ts&"
export * from "./LayoutHomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports